import React from 'react';
import SMFormTextArea from './SMFormTextArea';
import SMFormValidationMessage from './SMFormValidationMessage';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormTextAreaWithError extends SMFormFieldBaseView {
  
  render() {
    
    return (
      <div className="form-box">
        <SMFormTextArea
          delegate={this.props.delegate}
          className={this.props.className}
          name={this.props.name} 
          value={this.props.value} 
          placeholderText={this.props.placeholderText}
          options={this.props.options}
          placeholder={this.props.placeholderText} />
        <SMFormValidationMessage name={this.props.name} errorText={this.props.errorText} />
      </div>
    );
  }
}
SMFormTextAreaWithError.defaultProps = {
  options: {
    className: 'form-textarea w500 h80',
    disabled: false
  }
};
export default SMFormTextAreaWithError;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormTextAreaWithError.jsx